import React from 'react';
import { Users, Settings, Bell, Search, MoreVertical } from 'lucide-react';

const GroupChatHeader = ({ group, canModerate, onShowRoster }) => {
  const getGroupTitle = () => {
    return group?.title || 'Team Group Chat';
  };

  const getGroupInfo = () => {
    const memberCount = group?.participants?.length || 0;
    return `${memberCount} members`;
  };

  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
          <Users className="w-6 h-6 text-green-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">{getGroupTitle()}</h2>
          <p className="text-sm text-gray-500">{getGroupInfo()}</p>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <button
          onClick={onShowRoster}
          className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
          title="Show team roster"
        >
          <Users className="w-5 h-5" />
        </button>

        <button className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100">
          <Search className="w-5 h-5" />
        </button>

        <button className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100">
          <Bell className="w-5 h-5" />
        </button>

        {canModerate && (
          <button className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100">
            <Settings className="w-5 h-5" />
          </button>
        )}

        <button className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100">
          <MoreVertical className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default GroupChatHeader;